<template>
  <div ref="host" class="webVoiceAgentHost"></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { globalState } from '@/globalState';

const host = ref(null);
const route = useRoute();
let scriptEl = null;

function normalizeEndpoint(valueParam) {
  const value = typeof valueParam === 'string' ? valueParam.trim() : '';
  if (value === '') {
    return '';
  }
  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return '';
    }
    return parsed.origin;
  } catch (error) {
    return '';
  }
}

function resolveWebVoiceEndpoint() {
  let configuredEndpoint = '';
  if (window.env !== undefined && window.env !== null) {
    configuredEndpoint = normalizeEndpoint(window.env.VUE_APP_WEB_VOICE_ENDPOINT);
    if (configuredEndpoint === '') {
      configuredEndpoint = normalizeEndpoint(window.env.VUE_APP_PUBLIC_AGENT_SERVICE_ENDPOINT);
    }
  }
  if (configuredEndpoint === '') {
    configuredEndpoint = normalizeEndpoint(process.env.VUE_APP_WEB_VOICE_ENDPOINT);
  }
  if (configuredEndpoint === '') {
    configuredEndpoint = normalizeEndpoint(process.env.VUE_APP_PUBLIC_AGENT_SERVICE_ENDPOINT);
  }
  if (configuredEndpoint !== '') {
    return configuredEndpoint;
  }
  const apiEndpoint = normalizeEndpoint(globalState.apiEndpoint);
  if (apiEndpoint === '') {
    return '';
  }
  const apiUrl = new URL(apiEndpoint);
  const localHost = apiUrl.hostname === 'localhost' || apiUrl.hostname === '127.0.0.1' || apiUrl.hostname === '::1';
  if (localHost === true) {
    apiUrl.port = '5055';
    return apiUrl.origin;
  }
  return apiEndpoint;
}

function removeScript() {
  if (scriptEl !== null) {
    if (scriptEl.parentNode !== null) {
      scriptEl.parentNode.removeChild(scriptEl);
    }
    scriptEl = null;
  }
}

onMounted(() => {
  const id = route.params.agentid;
  const api = resolveWebVoiceEndpoint();
  if (host.value !== null && typeof id === 'string' && id !== '' && typeof api === 'string' && api !== '') {
    removeScript();
    const s = document.createElement('script');
    s.src = api + '/public/webVoiceAgent.js?v=voice-service-1';
    s.setAttribute('data-agent-id', String(id));
    s.setAttribute('data-voice-endpoint', String(api));
    s.setAttribute('data-target-element', '.webVoiceAgentHost');
    s.setAttribute('data-audio-quality', 'hd');
    s.setAttribute('data-open-on-load', 'true');
    s.defer = true;
    host.value.appendChild(s);
    scriptEl = s;
  }
});

onBeforeUnmount(() => {
  removeScript();
});
</script>

<style scoped>
.webVoiceAgentHost{width:100%;height:100vh;position:relative}
</style>


